import { postWithJson, get, uploadFile } from 'library/utils/http/axios'

/**
 * 获取用户信息
 */
export const userInfo = (params: {}) => postWithJson('/api/manager/login/info.json', params)

/**
 * 语音转码服务转成 mp3
 *
 * @returns {Promise}
 */
export const convertAmrToMp3 = (params: {}) => {
    return postWithJson('/wechat/convertMessageAmrToMp3.json', params)
}

/**
 * 部门列表树形结构+
 * @param { boolean= } isNeedPermissionControl 是否需要权限控制 true 当前用户权限范围内的部门 false 获取当前客户下的所有部门
 */
export const orgTreeList = (params: {}) => postWithJson('/api/manager/org/list.json', params)
/**
 * 查询部门对应的企微成员
 * @param { number } weworkDepartmentId 部门 id
 * @param { object } pageDto 分页对象
 */
export const orgWeworkUserList = (params: {}) => postWithJson('/api/manager/org/weworkUserList.json', params)

/**
 * 查询企微成员列表
 * @param { number } weworkDepartmentId 部门 id
 * @param { object } pageDto 分页对象
 */
export const weworkUserList = (params: {}) => postWithJson('/api/manager/org/weworkUserList.json', params)

/**
 * 成员详情列表
 * @param { string } weworkUserId 成员 id
 * @param { string } query 成员 / 别名
 * @param { string } nodeId 部门 id
 */
export const getWeworkUserDetail = (params: {}) => postWithJson('/api/manager/weworkUser/detail.json', params)
/**
 * 企业微信标签列表
 */
export const weworkTagList = (params: {}) => postWithJson('/api/manager/weworkTag/list.json', params)
/**
 * 获取客户阶段列表
 */
export const getStageList = (params = {}) => postWithJson('/api/manager/stage/list.json', params)

/**
 * 获取客户渠道
 */
export const getChannelList = (params = {}) => postWithJson('/api/manager/channel/list.json', params)

/**
 * 获取专属客服二维码
 */
export const qrcode = (params: {}) => postWithJson('/api/manager/qrcode.json', params)

/**
 * 上传文件至企微返回 url
 */
export const uploadWxFile = (params = {}) => postWithJson('/api/manager/common/uploadFile.json', params)

/**
 * 查询全部模块配置异常
 */
export const checkAllAvailable = () => postWithJson('/api/manager/common/checkAllAvailable.json')

/**
 * 查询过期时间
 */
export const overdueTime = () => postWithJson('/api/manager/overdue/time.json')

/**
 * 切换角色
 * @param { number } roleId 角色 id
 */
export const changeRole = (params: {}) => {
    return postWithJson('/api/manager/login/changeRole.json', params)
}

/**
 * 退出登录
 */
export const logout = (params: {}) => postWithJson('/api/manager/login/logout.json', params)

/**
 * 获取链接地址相关信息
 * @param { strinf } url url 地址
 */
export const getUrlInfo = (params = {}) => postWithJson('/api/manager/common/getUrlInfo.json', params)

/**
 * 获取区域列表
 * @return {Object}
 */
export const getAraeData = () => get('/pca.json')

/**
 * 人工外呼
 * @param { strinf } phone
 */
export const postCall = (params = {}) => postWithJson('/call/call.json', params)

/**
 * 获取通话详情
 */
export const getCallDetail = (params = {}) => postWithJson('/call/detail.json', params)

/**
 * 获取通话详情
 */
export const addTask = (params = {}) => postWithJson('/call/task/add.json', params)

/**
 * 任务下拉选择
 */
export const getTaskOptions = (params = {}) => postWithJson('/call/task/option.json', params)
/**
 * 短信签名列表
 */
export const messageSignatureList = (params = {}) => postWithJson('/api/manager/sms/signList.json', params)

/**
 * 模板下拉列表
 * 仅显示审核通过的模板
 */
export const templateSelectList = (params = {}) => postWithJson('/api/manager/sms/template/option.json', params)

/**
 * 新增短信任务
 * @param { string } batchId
 * @param { string } content 带有模板 {客户名称} {手机号}
 * @param { string } contentType
 * @param { string } reason
 * @param { string } signatureId
 */
export const newMessageTask = (params: {}) => postWithJson('/api/manager/sms/task/add.json', params)

/**
 * 应用列表
 * @return {Object}
 */
export const getApplicationList = () => postWithJson('/app/list.json')

/**
 * 用户手动关闭外呼弹框
 * @return {Object}
 */
export const cancelCall = () => postWithJson('/call/cancel.json')

/**
 * 获取表单预览
 */
export const getFormDetail = (params: {}) => postWithJson('/api/manager/dynamicForm/detail.json', params)
/**
 * 获取客户表单提交列表
 */
export const contactSubmitDetail = (params: {}) => postWithJson('/api/manager/dynamicForm/submitList.json', params)
/**
 * 表单发布详情
 */
export const getReleaseInfo = (params: {}) => postWithJson('/api/manager/dynamicForm/getReleaseInfo.json', params)
/**
 * 表单发布
 */
export const releaseForm = (params: {}) => postWithJson('/api/manager/dynamicForm/release.json', params)

/**
 * 接听电话时 注册
 */
export const callInRegister = (params: {}) => postWithJson('/call/in/register.json', params)

/**
 * 是否开通crm
 */
export const getIsOpenCrm = () => postWithJson('/call/isOpenCrm.json')

/**
 * 获取访问唯一编码
 */
export const getAccessNum = () => postWithJson('/common/getAccessNum.json')

/**
 * 上报用户浏览数据
 */
export const reportTp = (params: {}) => postWithJson('/common/report.json', params)

/**
 * 网络sip获取sessionId
 */
export const getSipSessionId = (params = {}) => postWithJson('/call/getCallSessionId.json', params)

/**
 * 获取登录二维码需要的key
 */
export const qrcodeImageKey = () => get('/dkf/getAuthUrl.json')

/**
 * 轮询查询登录状态
 */
export const checkStatus = () => get('/dkf/authStatus.json')

/**
 * batchId获取手机号
 */
export const getPhoneByBatchId = (params = {}) => postWithJson('/contact/phoneByBatchId.json', params)

/**
 * 获得订单来源
 */
export const getOrderSources = (params = {}) => postWithJson('/api/manager/trade/order/getConfig.json', params)

export const dashboardMenu = () => postWithJson('/login/dashboard.json')
// 常量列表
export const getConstantList = (params = {}) => get('/crm/common/constantList.json', params)
/**
 * 系统消息
 */
export const getNoticeList = (params = {}) => postWithJson('/notice/noticeList.json', params)

/**
 * 系统消息 全部已读
 */
export const dealAllNotice = (params = {}) => postWithJson('/notice/dealAll.json', params)

/**
 * 系统消息 单条已读
 */
export const haveDealNotice = (params = {}) => postWithJson('/notice/haveDeal.json', params)

// 语音上传接口，获取mp3url和silkUrl
export const uploadVoice = (params = {}) => postWithJson('/common/uploadVoice.json', params)

// 通用分组-新增
export const groupAdd = (params = {}) => postWithJson('/api/manager/group/add.json', params)

// 通用分组-编辑
export const groupEdit = (params = {}) => postWithJson('/api/manager/group/mod.json', params)

// 通用分组-删除
export const groupDel = (params = {}) => postWithJson('/api/manager/group/del.json', params)

// 通用分组-查询
export const groupList = (params = {}) => postWithJson('/api/manager/group/list.json', params)

// 通用分组-批量移动分组
export const groupMove = (params = {}) => postWithJson('/api/manager/group/move.json', params)

// 查询当前成员机器人在线状态
export const searchVipStatus = (params = {}) => postWithJson('/vip/wework/current.json', params)

// 一键加好友
export const quickAddWechat = (params = {}) => postWithJson('/vipAddFriend/oneClickAdd.json', params)

// 新增导出数据
export const addExportCenter = (params = {}) => postWithJson('/api/manager/export/add.json', params)

// 清除未读导出数量
export const removeUnRead = () => postWithJson('/api/manager/export/removeUnReadCount.json')

// 获取导出列表
export const getExportList = (params = {}) => postWithJson('/api/manager/export/list.json', params)

// 查询已导出未读数量
export const getUnReadExport = () => postWithJson('/api/manager/export/queryUnReadCount.json')

// 渠道分组列表
export const getChannelGroupList = (params = {}) => postWithJson<ChannelGroupItem[]>('/api/manager/channel/groupList.json', params)

/**
 * 获取STS
 */
export const getSts = (params = {}) => {
    return get('/api/manager/common/getSTS.json', params)
}

/**
 * 修改密码
 */
export const modfyPassword = (params = {}) => postWithJson('/api/manager/user/modPassword.json', params)

/**
 * 校验旧密码
 */
export const verifyPassword = (params = {}) => postWithJson('/api/manager/user/verifyPassword.json', params)


// 后端上传
export const commonUpload = (params = {}) => uploadFile('/api/manager/common/upload.json', params)

/**
 * 语音素材列表
 * @param { number| string } query 素材id/素材名称
 * @param { number } type 素材类型
 * @param { object } pageDto 分页参数
 */
export const getVoiceList = (params: {}) => postWithJson('/call/voiceMaterial/list.json', params)

/**
 * 获取录音播放地址
 */
export const playVoiceRecord = (params: {}) => postWithJson('/call/playVoice.json', params)

/**
 * 获取h5链接
 */
export const quickH5Url = () => postWithJson('/api/manager/common/getAppH5Url.json')

/**
 * 获取小程序码
 */
export const quickMiniQrcode = () => postWithJson('/api/manager/weixin/applet/getAppletQrCodeUrl.json')

// 通过ticket判断当前商户bizId
export const getBizInfo = (params) => {
    return postWithJson('/api/app/bizInfo.json', params)
}

// 是否开启公众号
export const enableGzh = (params) => {
    return postWithJson('/api/manager/weixin/officialAccount/isAuthorized.json', params)
}

// 订单支付
export const setNotice = (params: {}) => {
    return postWithJson('/api/manager/setting/mod.json', params)
}

// 获取订单支付通知接口
export const getNotice = (params: {}) => {
    return postWithJson('/api/manager/setting/settingDetail.json', params)
}

// 是否开通了短信
export const isOpenSms = () => postWithJson('/api/manager/sms/isOpen.json')


export const getTaskProgress = (params: {}) => {
    return postWithJson('/api/manager/progress/get.json', params)
}

// 删除任务进度
export const deleteTaskProgress = (params: {}) => {
    return postWithJson('/api/manager/progress/delete.json', params)
}

// 获取授权公众号域名
export const getWeixinAuthAddress = (params: {}) => {
    return postWithJson('/api/manager/common/getWeixinAuthAddress.json', params)
}
